export const API_TOKEN = "OqTo9uQ8ml9usYD7r40ji7LkPjg7JkI5g7kpiWve";
export const API_BASE_URL = "https://api.hydrao.com";
